import React from "react";
import { Divider, Text } from "react-native-paper";
import { Image, View, StyleSheet } from "react-native";
import {
  whiteColor,
  blackColor,
  descriptionColor,
  dividerColor,
} from "../../common/colors";
import { List } from "react-native-paper";
import sections from "../colors/index";
import { Platform } from "react-native";
import AccordionItemFull from "../AccordionItemFull";
import AccordionItemText from "../AccordionItemText";
import AccordionItemImage from "../AccordionItemImage";
import AccordionItemDescription from "../AccordionItemDescription";
import AccordionItemDescriptionOnlyOne from "../AccordionItemDescriptionOnlyOne";
import AccordionItemDubleText from "../AccordionItemDubleText";
import AccordionItemOneAboveAnother from '../AccordionItemOneAboveAnother';

const SwitchAccordionItem = (props) => {
  if (
    props.subSection.description &&
    props.subSection.title &&
    props.subSection.image
  ) {
    return <AccordionItemFull {...props} />;
  }

  if (props.subSection.description1 && props.subSection.description2) {
    return <AccordionItemDubleText {...props} />;
  }

  if (props.subSection.isOneAboveAnother) {
    return <AccordionItemOneAboveAnother {...props} />;
  }

  if (props.subSection.description && props.subSection.title) {
    return <AccordionItemText {...props} />;
  }

  if (props.subSection.image) {
    return <AccordionItemImage {...props} />;
  }

  if (props.subSection.description) {
    return <AccordionItemDescription {...props} />;
  }

  if (props.subSection.title) {
    if (props.subSection.title.length === 1) {
      return <AccordionItemDescriptionOnlyOne {...props} />;
    }
    return <Text></Text>;
  }
};


const Accordion = (props) => (
  <List.AccordionGroup style={styles.list}>
    {sections &&
      sections[props.colorType] &&
      sections[props.colorType].map((section, id) =>{ 
        return (
        <React.Fragment key={`accordion-${id}`}>
          <Divider style={styles.divider} />
          <List.Accordion
            style={styles.titleOne}
            descriptionStyle={styles.text}
            titleStyle={styles.textTitle}
            title={section.title}
            id={id + 1}
          >{section.subSections && section.subSections.map((subSection, j) => (
              <SwitchAccordionItem
                styles={styles}
                j={j}
                subSection={subSection}
                key={`accordion-${id}-accordionItem-${j}`}
              />
            ))}
          </List.Accordion>
        </React.Fragment>
      );})}
  </List.AccordionGroup>
);

export default Accordion;

const styles = StyleSheet.create({
  subSection: {
    paddingTop: 10,
    paddingRight: 16,
    paddingLeft: 16,
    paddingBottom: 10,
    backgroundColor: whiteColor,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  list: {
    backgroundColor: whiteColor,
  },
  text: {
    color: blackColor,
  },
  image: {
    minHeight: !(Platform.OS === "android" || Platform.OS === "ios")
      ? 450
      : 300,
    width: "100%",
    height: undefined,
    aspectRatio: 1,
  },
  textTitle: {
    fontSize: 16,
    lineHeight: 16,
    letterSpacing: 0.25,
    color: blackColor,
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  textSubtitle: {
    fontSize: 14,
    lineHeight: 24,
    letterSpacing: 0.15,
    color: blackColor,
    fontWeight: "bold",
    width: "50%",
  },
  textdescriptionDesign: {
    fontSize: 14,
    lineHeight: 21,
    letterSpacing: 0.25,
    color: descriptionColor,
    fontWeight: "400",
    width: "50%",
  },
  textdescriptionDesignOne: {
    fontSize: 14,
    lineHeight: 21,
    letterSpacing: 0.25,
    color: descriptionColor,
    fontWeight: "400",
    width: "100%",
  },
  title: {
    textAlign: "center",
    fontSize: 20,
    lineHeight: 16,
    letterSpacing: 1.25,
    paddingBottom: 24,
    paddingTop: 10,
    color: blackColor,
  },
  titleColor: {
    textAlign: "center",
    fontSize: 16,
    lineHeight: 16,
    letterSpacing: 1.25,
    paddingBottom: 16,
    paddingTop: 10,
    color: blackColor,
  },
  contentContainer: {
    backgroundColor: whiteColor,
    color: blackColor,
    width: "100%",
  },
  container: {
    width: "100%",
  },
  titleOne: {
    textAlign: "left",
    fontSize: 24,
    lineHeight: 16,
    paddingTop: 20,
    letterSpacing: 0.15,
    backgroundColor: whiteColor,
  },
  divider: {
    width: "100%",
    backgroundColor: dividerColor,
  },
  scrollView: {
    backgroundColor: whiteColor,
    paddingBottom: 30,
  },
});
